import 'react';
import createSvgIcon from '../../utils/createSvgIcon.js';
import { jsx } from 'react/jsx-runtime';

var KeyboardArrowLeft = createSvgIcon( /*#__PURE__*/jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');

export { KeyboardArrowLeft as default };
//# sourceMappingURL=KeyboardArrowLeft.js.map
